import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { NgIf } from '@angular/common';
import HeaderComponent from './shared/components/header/header.component';
import { MarketingHeaderComponent } from './shared/components/marketing-header/marketing-header.component';
import FooterComponent from './shared/components/footer/footer.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [NgIf, RouterOutlet, HeaderComponent, MarketingHeaderComponent, FooterComponent],
  standalone: true
})
export default class AppComponent {
  public appClassWrapper: string = '';

  public marketingPage = false;

  public maintenancePage = false;

  public hideHeader: boolean = false;

  public hideFooter: boolean = false;

  public urlsToHideHeader = ['/marketing-consent/', 'maintenance'];

  public urlsToHideFooter = ['/marketing-consent/', 'maintenance'];

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute
  ) {
    this.hideHeaderByUrl(this.router.url);
    this.hideFooterByUrl(this.router.url);

    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd
        )
      )
      .subscribe((val: NavigationEnd) => {
        this.appClassWrapper = 'site-wrapper';
        this.activatedRoute.firstChild?.data.subscribe((data) => {
          this.marketingPage = !!data['isMarketingPage'];
        });

        this.hideHeaderByUrl(val.url);

        this.hideFooterByUrl(val.url);
      });
  }

  hideHeaderByUrl(url: string) {
    this.activatedRoute.paramMap.subscribe(() => {
      this.hideHeader = this.urlsToHideHeader.some((item: string) =>
        url.includes(item)
      );
    });
  }

  hideFooterByUrl(url: string) {
    this.activatedRoute.paramMap.subscribe(() => {
      this.hideFooter = this.urlsToHideHeader.some((item: string) =>
        url.includes(item)
      );
    });
  }
}
